import {NavbarProps} from '@common/ui/navigation/navbar/navbar';
import {useNavigate} from '@common/ui/navigation/use-navigate';
import {Button} from '@ui/buttons/button';
import {ButtonColor} from '@ui/buttons/get-shared-button-style';
import {IconButton} from '@ui/buttons/icon-button';
import {Item} from '@ui/forms/listbox/item';
import {Trans} from '@ui/i18n/trans';
import {PersonIcon} from '@ui/icons/material/Person';
import {Menu, MenuTrigger} from '@ui/menu/menu-trigger';
import {useSettings} from '@ui/settings/use-settings';
import {Fragment} from 'react';
import {Link} from 'react-router';

function useVisibleAuthButtons() {
  const {registration, auth} = useSettings();
  return {
    showLogin: !auth?.hide_login,
    showRegister: !registration?.disable,
  };
}

interface NavbarAuthButtonsProps {
  primaryButtonColor?: ButtonColor;
  navbarColor?: NavbarProps['color'];
}
export function NavbarAuthButtons({
  primaryButtonColor,
  navbarColor,
}: NavbarAuthButtonsProps) {
  const {showLogin, showRegister} = useVisibleAuthButtons();

  if (!primaryButtonColor) {
    primaryButtonColor = navbarColor === 'primary' ? 'elevated' : 'primary';
  }

  if (!showLogin && !showRegister) {
    return null;
  }

  return (
    <Fragment>
      <MobileButtons />
      <DesktopButtons primaryButtonColor={primaryButtonColor} />
    </Fragment>
  );
}

interface DesktopButtonsProps {
  primaryButtonColor: ButtonColor;
}
function DesktopButtons({primaryButtonColor}: DesktopButtonsProps) {
  const {showLogin, showRegister} = useVisibleAuthButtons();
  return (
    <div className="text-sm max-md:hidden">
      {showRegister && (
        <Button
          elementType={Link}
          to="/register"
          variant={showLogin ? 'text' : 'raised'}
          color={showLogin ? undefined : primaryButtonColor}
          className={showLogin ? 'mr-10' : undefined}
        >
          <Trans message="Register" />
        </Button>
      )}
      {showLogin && (
        <Button
          elementType={Link}
          to="/login"
          variant="raised"
          color={primaryButtonColor}
        >
          <Trans message="Login" />
        </Button>
      )}
    </div>
  );
}

function MobileButtons() {
  const {showLogin, showRegister} = useVisibleAuthButtons();
  const navigate = useNavigate();
  return (
    <MenuTrigger>
      <IconButton size="md" className="md:hidden">
        <PersonIcon />
      </IconButton>
      <Menu>
        {showLogin && (
          <Item value="login" onSelected={() => navigate('/login')}>
            <Trans message="Login" />
          </Item>
        )}
        {showRegister && (
          <Item value="register" onSelected={() => navigate('/register')}>
            <Trans message="Register" />
          </Item>
        )}
      </Menu>
    </MenuTrigger>
  );
}
